import {useTranslation} from 'react-i18next';

import {useLocation} from '@remix-run/react';
import {Breadcrumb, MediaShowcase} from '~/features/shared';
import {ProductDetails} from '../../../types/ProductDetails';

export const GAP = 40;
export const PADDING_HEIGHT = 200;
export const HEIGHT = 400;
export const BOTTOM = -HEIGHT + PADDING_HEIGHT - GAP;

export function Header({product}: {product: ProductDetails}) {
  const {t} = useTranslation();
  const location = useLocation();

  const fromProductos = location.state?.from === '/productos';

  return (
    <section>
      <div
        className="flex relative flex-col gap-4 py-10 px-5 mb-10 bg-gray-100 md:px-10 lg:px-28 lg:pt-24 lg:rounded-3xl"
        style={{
          paddingBottom: PADDING_HEIGHT,
        }}
      >
        <h1 className="text-xs tracking-widest uppercase text-blue-dark">
          {product.productType}
        </h1>

        <h1 className="text-4xl font-bold uppercase">{product.title}</h1>

        <div>
          <p className="font-medium text-gray-600">{product.categoryName}</p>
        </div>

        <hr className="h-px bg-black s-full" />

        <div className="flex justify-betseen">
          <Breadcrumb
            items={[
              {
                title: t('inicio'),
                to: '/',
              },
              {
                title: t('productos'),
                to: '/productos',
                navigateBack: fromProductos,
              },
              {
                title: product.categoryName,
              },
              {
                title: product.title,
              },
            ]}
          />

          {/* <p className="text-sm font-medium text-gray-500">{product.vendor}</p> */}
        </div>

        <MediaShowcase
          key={product.handle + '-desktop'}
          media={product.media}
          height={HEIGHT}
          className="absolute inset-x-5 md:inset-x-10"
          style={{
            bottom: BOTTOM,
          }}
        />
      </div>

      <div
        style={{
          height: -BOTTOM,
          background: 'transparent',
        }}
      />
    </section>
  );
}
